import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';
import { UspGroupItemContainer } from './components/UspGroupItemContainer/UspGroupItemContainer.js';
import { UspGroupItemLink } from './components/UspGroupItemLink/UspGroupItemLink.js';

const UspGroupItem = ({ item , renderAsListItem  })=>{
    const { icon , text  } = item;
    return /*#__PURE__*/ React.createElement(UspGroupItemContainer, {
        renderAsListItem: renderAsListItem
    }, /*#__PURE__*/ React.createElement(UspGroupItemLink, {
        item: item,
        className: "usp-group-item"
    }, icon && /*#__PURE__*/ React.createElement("span", {
        className: "usp-group-item__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 18,
        height: 18
    })), /*#__PURE__*/ React.createElement("span", {
        className: "usp-group-item__message"
    }, text)));
};

export { UspGroupItem, UspGroupItem as default };
//# sourceMappingURL=UspGroupItem.js.map
